import { DataSourceAction, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutPayeeDriversQuickInfo } from "./autogen/AutogenLayoutPayeeDriversQuickInfo";
import { ModelRow } from "@mcleod/core";

export class PayeeDriversQuickInfo extends AutogenLayoutPayeeDriversQuickInfo {
    sourcePayeeDriversAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            const searchResults: ModelRow[] = this.mainDataSource?.data;
            if (searchResults == null || searchResults[0]?.data?.["driver.id"] == null) {
                this.tableDrivers.visible = false;
                this.labelNoDrivers.visible = true;
            }
        }
    }
}
